<div class="production-db-content" direction="languageDir">
  <!-- <div class="content-top-box">
    <ul class="breadcrumb">
      <ul class="breadcrumb">
        <li class="breadcrumb-item" *ngFor="let breadcrumItem of breadcrumList">
          <a class="breadcrumb-link" [routerLink]="breadcrumItem.Url" [id]="breadcrumItem.id"
            (click)="DisplayRightmenu(breadcrumItem.id, breadcrumItem.Url)">{{lang.getTransalatedValue(breadcrumItem.text)}}</a>
        </li>
      </ul>
    </ul>
   <div class="title-row-flex-both-end subscription-form-content-nav">
      <h1 class="main-title text-white col-3">{{langObj ? langObj?.FormBuilder : ('FormBuilder' | translate)}}</h1>
    </div> 
  </div> -->
  <app-bread-crumb></app-bread-crumb>
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>
  <!-- <header> -->
  <div class="subscription-form-content-nav  d-flex align-items-center">
    <div class="container-fluid">
      <div class="row">
        <div class="col-3 col-md-3 text-white">
          <!-- <i class="fas fa-cubes me-2"></i> -->
          <span translate class="heading-title">{{langObj ? langObj?.o3formbuilder : ('o3formbuilder' |
            translate)}}</span>
        </div>
        <div class="col-9 col-md-9 text-end p-0">
          <button class="btn btn-fix ms-2" (click)="openApprovalModel()">
            <i class="fa-regular fa-clipboard me-2"></i>
            <span translate>{{langObj ? langObj?.Approval : ('Approval' | translate)}}</span>
          </button>
          <button class="btn btn-fix ms-2" (click)="openFormDetailModel()">
            <i class="fa-regular fa-eye me-2"></i>
            <span translate>{{langObj ? langObj?.DetailFrom : ('DetailFrom' | translate)}}</span>
          </button>
          <button class="btn btn-fix ms-2" (click)="openSaveModel()">
            <i class="fa-regular fa-floppy-disk me-2"></i>
            <span translate>{{langObj ? langObj?.saveform : ('saveform' | translate)}}</span>
          </button>
          <button class="btn btn-fix ms-2" (click)="onPreview()">
            <i class="fas fa-search me-2"></i>
            <span translate>Preview</span>
          </button>
          <!-- <button class="btn btn-fix ms-2" (click)="generateHtml()">
            <i class="far fa-file-code me-2"></i>
            <span translate>Generate HTML</span>
          </button> 
          <button class="btn btn-fix ms-2 me-2" (click)="generateJson()">
            <i class="fas fa-code me-2"></i>
            <span translate>Generate JSON</span>
          </button> -->
          <div ngbDropdown class="d-inline-block me-2">
            <!-- <button type="button" class="btn btn-fix" id="dropdownBasic1" ngbDropdownToggle>
              <i class="fas fa-language me-1"></i> {{ currentLanguage }}
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem translate (click)="changeLanguage('en-US')">
                English
              </button>
              <button ngbDropdownItem translate (click)="changeLanguage('vi-VN')">
                Vietnamese
              </button>
              <button ngbDropdownItem translate (click)="changeLanguage('ja-JP')">
                Japanese
              </button>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </header> -->
  <mat-card class="mat-mar-top">
    <ng-template #recursiveList let-elements>
      <div dndPlaceholderRef class="dndPlaceholder"></div>
      <div *ngFor="let component of elements" class="selected-component"
        [ngClass]="{ 'is-selected': component.isSelected }" (click)="setSelectedComponent($event, component)"
        dndEffectAllowed="move" [dndDraggable]="component" (dndStart)="onDragStart($event)"
        (dndCopied)="onDragged(component, elements, 'copy')" (dndLinked)="onDragged(component, elements, 'link')"
        (dndMoved)="onDragged(component, elements, 'move')" (dndCanceled)="onDragged(component, elements, 'none')"
        (dndEnd)="onDragEnd($event)">
        <ng-container [ngSwitch]="component.elementName">
          <ng-container *ngTemplateOutlet="sectionTpl; context: { $implicit: component }"></ng-container>
          <app-text *ngSwitchCase="'text'" [component]="component"></app-text>
          <app-picture *ngSwitchCase="'picture'" [component]="component"></app-picture>
          <app-button *ngSwitchCase="'button'" [component]="component"></app-button>
          <app-textarea *ngSwitchCase="'textarea'" [component]="component"
            [formDesign]="subscriptionForm.content_dnd.form_design"></app-textarea>
          <app-spacer *ngSwitchCase="'spacer'" [component]="component"></app-spacer>
          <app-separator *ngSwitchCase="'separator'" [component]="component"></app-separator>
          <app-social *ngSwitchCase="'social'" [component]="component"></app-social>
          <app-checkbox *ngSwitchCase="'checkbox'" [component]="component"
            [formDesign]="subscriptionForm.content_dnd.form_design"></app-checkbox>
          <app-dropdown *ngSwitchCase="'dropdown'" [component]="component"
            [formDesign]="subscriptionForm.content_dnd.form_design"></app-dropdown>
          <app-radios *ngSwitchCase="'radios'" [component]="component"
            [formDesign]="subscriptionForm.content_dnd.form_design"></app-radios>
          <app-input *ngSwitchCase="'input'" [component]="component"
            [formDesign]="subscriptionForm.content_dnd.form_design"></app-input>
          <app-uploader *ngSwitchCase="'uploader'" [component]="component"
            [formDesign]="subscriptionForm.content_dnd.form_design"></app-uploader>
          <app-list *ngSwitchCase="'list'" [component]="component"
            [formDesign]="subscriptionForm.content_dnd.form_design"></app-list>
        </ng-container>
        <div dndDragImageRef class="my_placeholder"></div>
        <div class="drag-handler rounded-circle" dndHandle>
          <i class="fas fa-arrows-alt"></i>
        </div>
        <div class="container-action-wrapper" *ngIf="component.deletable">
          <button class="btn btn-sm btn-danger" placement="bottom" ngbTooltip="{{ 'Delete' | translate }}"
            (click)="deleteComponent($event, component.id)">
            <i class="fas fa-trash"></i>
          </button>
        </div>
      </div>
    </ng-template>

    <ng-template #sectionTpl let-component>
      <div class="row no-gutters" [ngSwitch]="component.column">
        <ng-container *ngSwitchCase="'2-1-3'">
          <div class="col-4 border border-primary border-dashed section-area" [ngClass]="{
            'not-added-component': component.addedComponents[0].length === 0
          }" [dndDropzone]="['nc']" (dndDrop)="onDrop($event, component.addedComponents[0])">
            <ng-container *ngTemplateOutlet="
              recursiveList;
              context: { $implicit: component.addedComponents[0] }
            ">
            </ng-container>
          </div>
          <div class="col-8 border border-primary border-dashed section-area" [ngClass]="{
            'not-added-component': component.addedComponents[1].length === 0
          }" [dndDropzone]="['nc']" (dndDrop)="onDrop($event, component.addedComponents[1])">
            <ng-container *ngTemplateOutlet="
              recursiveList;
              context: { $implicit: component.addedComponents[1] }
            ">
            </ng-container>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'2-3-1'">
          <div class="col-8 border border-primary border-dashed section-area" [ngClass]="{
            'not-added-component': component.addedComponents[0].length === 0
          }" [dndDropzone]="['nc']" (dndDrop)="onDrop($event, component.addedComponents[0])">
            <ng-container *ngTemplateOutlet="
              recursiveList;
              context: { $implicit: component.addedComponents[0] }
            ">
            </ng-container>
          </div>
          <div class="col-4 border border-primary border-dashed section-area" [ngClass]="{
            'not-added-component': component.addedComponents[1].length === 0
          }" [dndDropzone]="['nc']" (dndDrop)="onDrop($event, component.addedComponents[1])">
            <ng-container *ngTemplateOutlet="
              recursiveList;
              context: { $implicit: component.addedComponents[1] }
            ">
            </ng-container>
          </div>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <div class="col border border-primary border-dashed section-area"
            *ngFor="let c of component.addedComponents; let i = index" [ngClass]="{
            'not-added-component': component.addedComponents[i].length === 0
          }" [dndDropzone]="['nc']" (dndDrop)="onDrop($event, component.addedComponents[i])">
            <ng-container *ngTemplateOutlet="
              recursiveList;
              context: { $implicit: component.addedComponents[i] }
            ">
            </ng-container>
          </div>
        </ng-container>
      </div>
    </ng-template>

    <ng-template #popTitle><span translate>Add New Section</span>
      <a class="fas fa-times float-end" (click)="closePopover()"></a></ng-template>

    <ng-template #popContent>
      <div class="container-fluid">
        <div class="row">
          <div class="col-6 mb-3" *ngFor="let sectionComponent of sectionComponents">
            <img [src]="sectionComponent.image" alt="" class="img-fluid" [dndDraggable]="sectionComponent"
              [dndType]="'se'" (dndStart)="onDragStart($event)"
              (dndCopied)="onDragged(sectionComponent, addedComponents, 'copy')"
              (dndLinked)="onDragged(sectionComponent, addedComponents, 'link')"
              (dndMoved)="onDragged(sectionComponent, addedComponents, 'move')"
              (dndCanceled)="onDragged(sectionComponent, addedComponents, 'none')" (dndEnd)="onDragEnd($event)" />
          </div>
        </div>
      </div>
    </ng-template>

    <section>
      <div class="p-0 rounded" id="form-builder-wrapper">
        <div *ngIf="subscriptionForm">
          <div class="construct-container d-flex justify-content-between px-3">
            <div class="panel-elements pt-0">
              <div class="email-structure">
                <div class="component section-component rounded" [ngbPopover]="popContent" [popoverTitle]="popTitle"
                  placement="right" container="body" [autoClose]="false" triggers="manual" #popover="ngbPopover"
                  (click)="popover.open()">
                  <p><i class="fas fa-columns fa-2x custom-icon"></i></p>
                  <span translate>Section</span>
                </div>
                <div class="component rounded" *ngFor="let component of components" [dndDraggable]="component"
                  [dndType]="'nc'" (dndStart)="onDragStart($event)"
                  (dndCopied)="onDragged(component, addedComponents, 'copy')"
                  (dndLinked)="onDragged(component, addedComponents, 'link')"
                  (dndMoved)="onDragged(component, addedComponents, 'move')"
                  (dndCanceled)="onDragged(component, addedComponents, 'none')" (dndEnd)="onDragEnd($event)">
                  <p><i [class]="component.iconClass"></i></p>
                  <span translate>{{ component.name }}</span>
                </div>
              </div>
            </div>
            <div class="form-body flex-grow-1">
              <div class="email-body d-flex content-droppable-zone {{
                dragStartClass
              }} dndList" [ngClass]="{
                'align-items-start':
                  subscriptionForm.content_dnd.form_design.page_alignment === 'top',
                'align-items-center':
                  subscriptionForm.content_dnd.form_design.page_alignment === 'center',
                'align-items-end':
                  subscriptionForm.content_dnd.form_design.page_alignment === 'bottom'
              }" [ngStyle]="{
                'font-family':
                  subscriptionForm.content_dnd.form_design.font_family,
                'font-size':
                  subscriptionForm.content_dnd.form_design.font_size + 'px',
                background:
                  subscriptionForm.content_dnd.form_design.background_color,
                padding:
                  subscriptionForm.content_dnd.form_design.page_paddings + 'px'
              }">
                <div class="form-container mx-auto" dndDropzone (dndDrop)="
                  onDrop($event, subscriptionForm.content_dnd.added_components)
                " [ngStyle]="{
                  width: subscriptionForm.content_dnd.form_design.fullWidth
                    ? '100%'
                    : subscriptionForm.content_dnd.form_design.width + 'px',
                  'background-color':
                    subscriptionForm.content_dnd.form_design
                      .container_background_color,
                  'border-radius':
                    subscriptionForm.content_dnd.form_design.rounded_corners +
                    'px',
                  padding:
                    subscriptionForm.content_dnd.form_design.form_paddings + 'px',
                  border:
                    'solid ' +
                    subscriptionForm.content_dnd.form_design.form_border_width +
                    'px ' +
                    subscriptionForm.content_dnd.form_design.form_border_color
                }">
                  <ng-container *ngTemplateOutlet="
                    recursiveList;
                    context: {
                      $implicit: subscriptionForm.content_dnd.added_components
                    }
                  "></ng-container>
                </div>
              </div>
            </div>
            <div class="panel-options property-column">
              <div class="property-column-inner">
                <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs">
                  <li [ngbNavItem]="1" id="tab-current-element">
                    <a ngbNavLink translate>Current Element</a>
                    <ng-template ngbNavContent>
                      <app-current-element [selectedComponent]="selectedComponent"></app-current-element>
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="2" id="tab-form-design">
                    <a ngbNavLink translate>Form Design</a>
                    <ng-template ngbNavContent>
                      <app-form-design-property
                        [formDesign]="subscriptionForm.content_dnd.form_design"></app-form-design-property>
                    </ng-template>
                  </li>
                  <!-- <li [ngbNavItem]="3" id="tab-form-data">
                    <a ngbNavLink translate>Data</a>
                    <ng-template ngbNavContent>
                     
                    </ng-template>
                  </li> -->
                </ul>
                <div [ngbNavOutlet]="nav" class="mt-2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </mat-card>
</div>

<ng-template #SaveFormPoup>
  <div mat-dialog-title class="mat-title">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="main-title">{{langObj ? langObj?.saveform : ('saveform' | translate)}}</h1>
      <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>
    <div class="five-s-divider">
      <form [formGroup]="saveform">
        <div class="content-top-row content-top-row-order-processing">
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            *ngIf="actionType !== 'copyform' && formData?.id === null">
            <input matInput formControlName="formName"
              placeholder="{{langObj ? langObj?.formname : ('formname' | translate)}}"
              (keypress)="blockSpecialCharacters($event)">
            <mat-error class="error-msg" *ngIf="checkError('formName', 'required')">
              This field is required
            </mat-error>
            <mat-error class="error-msg" *ngIf="saveform.get('formName')?.errors?.pattern">
              Only alphanumeric characters and spaces are allowed
            </mat-error>
          </mat-form-field>

          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-select [disabled]="(formData?.id !== null && actionType !== 'copyform')" formControlName="pageType"
              placeholder="{{langObj ? langObj?.formType : ('formType' | translate)}}" panelClass="testClass">
              <mat-option *ngFor="let type of formTypes" [value]="type.value">
                {{type.label}}
              </mat-option>
            </mat-select>
            <mat-error class="error-msg" *ngIf="checkError('pageType', 'required')">Form type is required</mat-error>
          </mat-form-field>
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-select [disabled]="(formData?.id !== null && actionType !== 'copyform')" formControlName="page"
              placeholder="{{langObj ? langObj?.page : ('page' | translate)}}" panelClass="testClass" name="Status">
              <mat-select-filter [placeholder]="'Search'" [displayMember]="'Label'" [array]="pageList"
                (filteredReturn)="filteredPages = $event"></mat-select-filter>
              <mat-option *ngFor="let page of filteredPages" [value]="page.MenuId">
                {{page.Label}}
              </mat-option>
            </mat-select>
            <mat-error class="error-msg" *ngIf="checkError('page', 'required')">Page field is required</mat-error>
          </mat-form-field>
          <div class="btn-position">
            <!-- <button mat-raised-button color="accent" class="btn-accent" >{{langObj ? langObj?.save : ('save' | translate)}}</button> -->
            <button mat-mini-fab color="primary" type="submit" tooltipPosition="top"
              (click)="this.actionType === 'copyform' ?copyFormData() : saveFormData()">
              <mat-icon style="color: #fff">save</mat-icon>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #FormDetailPopup>
  <div mat-dialog-title class="mat-title">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="main-title">{{langObj ? langObj?.DetailFrom : ('DetailFrom' | translate)}}</h1>
      <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>
    <div class="five-s-divider">
      <form [formGroup]="DetailFrom">

        <div class="content-top-row content-top-row-order-processing">
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-select formControlName="page" placeholder="{{langObj ? langObj?.page : ('page' | translate)}}"
              panelClass="testClass" name="Status">
              <mat-select-filter [placeholder]="'Search'" [displayMember]="'Label'" [array]="pageList"
                (filteredReturn)="filteredPages = $event"></mat-select-filter>
              <mat-option *ngFor="let page of filteredPages" [value]="page.MenuId">
                {{page.Label}}
              </mat-option>
            </mat-select>
            <mat-error class="error-msg" *ngIf="checkError('page', 'required')">Page field is required</mat-error>
          </mat-form-field>
          <div class="btn-position">
            <!-- <button mat-raised-button color="accent" class="btn-accent" >{{langObj ? langObj?.save : ('save' | translate)}}</button> -->
            <button mat-mini-fab color="primary" type="submit" tooltipPosition="top" (click)=" getAllForms()">
              <mat-icon style="color: #fff">search</mat-icon>
            </button>
          </div>
        </div>
      </form>
      <ag-grid-angular style="width: 100%; height: 24vw;" class="ag-theme-alpine" [rowData]="rowDataBuilder"
        [columnDefs]="columnDefsBuilder" (gridReady)="onGridReady($event)" [gridOptions]="gridOptions"
        [pagination]="true" [paginationPageSize]="10" [components]="frameworkComponents">
      </ag-grid-angular>
    </div>
  </div>
</ng-template>
<ng-template #ApprovalPopup>
  <div mat-dialog-title class="mat-title approval-popup-container">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="main-title">
        {{ langObj ? langObj?.Approval : ('Approval' | translate) }}
      </h1>
      <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close" (click)="closeApprovalModel()">
        <i class="fa fa-times" style="color:#fff"></i>
      </button>
    </div>
    <div class="five-s-divider approval-popup-form">
      <form [formGroup]="ApprovalForm" (ngSubmit)="submitWorkflow()">
        <div class="content-top-row content-top-row-order-processing">
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-select formControlName="page" (selectionChange)="getWorkflows()"
              placeholder="{{ langObj ? langObj?.page : ('page' | translate) }}" panelClass="testClass" name="Status">
              <mat-select-filter [placeholder]="'Search'" [displayMember]="'Label'" [array]="pageListApproval"
                (filteredReturn)="filteredPagesApproval = $event">
              </mat-select-filter>
              <mat-option *ngFor="let page of filteredPagesApproval" [value]="page.MenuId">
                {{ page.Label }}
              </mat-option>
            </mat-select>
            <mat-error class="error-msg" *ngIf="checkErrorApproval('page', 'required')">

            </mat-error>
          </mat-form-field>
          <!-- <div class="btn-position">
            <button mat-mini-fab color="primary" type="submit" tooltipPosition="top" (click)="getApprovalForms()">
              <mat-icon style="color:#fff">search</mat-icon>
            </button>
          </div> -->
        </div>

        <!-- Scrollable approval levels -->
        <div formArrayName="approvalLevels" class="approval-levels-scroll">
          <div class="content-top-row content-top-row-order-processing"
            *ngFor="let levelGroup of ApprovalForm?.get('approvalLevels')?.['controls'] || []; let i = index"
            [formGroupName]="i">
            <div class="d-flex align-items-start w-100">
              <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing flex-grow-1">
                <mat-label>{{ 'Level ' + (i + 1) }}</mat-label>
                <mat-select formControlName="approvers" multiple (selectionChange)="selectedUsers(i, $event)"
                  placeholder="{{ langObj ? langObj?.approvers : ('approvers' | translate) }}" panelClass="testClass">

                  <mat-select-filter [placeholder]="'Search'" [displayMember]="'fullName'" [array]="usersList"
                    (filteredReturn)="filteredUsers = $event">
                  </mat-select-filter>

                  <mat-option *ngFor="let user of usersList" [value]="user.userCode"
                    [class.hidden-option]="!isUserVisible(user)">
                    {{ user.fullName }}
                  </mat-option>
                </mat-select>
                <mat-error class="error-msg"
                  *ngIf="levelGroup.get('approvers')?.touched && levelGroup.get('approvers')?.errors?.required">
                </mat-error>
              </mat-form-field>

              <button type="button" mat-mini-fab color="primary" class="ms-2 mt-1"
                *ngIf="i === ((ApprovalForm?.get('approvalLevels')?.['controls']?.length || 0) - 1)"
                (click)="addApprovalLevel()" matTooltip="Add Level">
                <mat-icon style="color:#fff">add</mat-icon>
              </button>

              <button type="button" mat-mini-fab color="warn" class="ms-2 mt-1" *ngIf="approvalLevels.length > 1"
                (click)="removeApprovalLevel(i)" matTooltip="Remove Level">
                <mat-icon style="color:#fff">remove</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="btn-position mt-3" style="padding-left: 25px;">
          <button mat-raised-button color="primary" type="submit">
            Save Workflow
          </button>
        </div>
      </form>
    </div>
  </div>

  <ag-grid-angular style="width:100%; height:18vw;" class="ag-theme-alpine approval-popup-grid" [rowData]="workflows"
    [columnDefs]="workflowDefs" (gridReady)="onWorkflowGridReady($event)" [gridOptions]="gridOptions"
    [pagination]="true" [paginationPageSize]="10" [components]="frameworkComponents">
  </ag-grid-angular>
</ng-template>
<ng-template #ViewApproversDialog>
  <div mat-dialog-title class="mat-title">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="main-title">Workflow Approvers</h1>
      <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>
  </div>
  <mat-dialog-content class="five-s-divider">
    <div *ngIf="approversView?.length; else noApprovers">
      <div *ngFor="let level of approversView" class="mb-3 p-3 border rounded">
        <div class="d-flex align-items-center"></div>
        <strong class="text-primary me-2">Level {{ level.level }}:</strong>
        <span class="d-inline-block" style="word-wrap: break-word; white-space: normal; max-width: 100%;">{{
          level.approvers.join(', ') }}</span>
      </div>
    </div>
    <ng-template #noApprovers>
      <p class="text-muted text-center py-3">No approvers found.</p>
    </ng-template>
  </mat-dialog-content>
</ng-template>